import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { logout } from '../actions';
import { updateUser } from '../../user/actions';
import { reloadUser } from './reloadUser';
import { eventFlowUpdate } from '../../events/actions';
import { ReduxState } from '../../state';

export const checkLoginCookies = () => {
  return async (dispatch: Dispatch<any>, getState: () => ReduxState) => {
    const { eventFlow } = getState().events;
    const tokenId = localStorage.getItem('showfaPagesLoginToken');
    const userId = localStorage.getItem('showfaPagesUserId');
    if (tokenId && userId) {
      try {
        const response = await backend.post('/api/v1/check-token', { tokenId, userId, app: 'pages-ui' });
        if (response.status === 200) {
          dispatch(reloadUser(tokenId, userId));
          dispatch(eventFlowUpdate({ ...eventFlow, userId }))
        } else {
          dispatch(logout());
          dispatch(updateUser(null));
        }
      } catch (error) {
        console.error('Error checking token:', error);
        dispatch(logout());
        dispatch(updateUser(null));
      }
    } else {
      dispatch(logout());
      dispatch(updateUser(null));
    }
  };
};